import {
  WithLayoutProps,
  withLayout,
} from 'style-utils/withStyledProps/withLayoutProps';
import styled from 'styled-components';

export const Box = styled.div<WithLayoutProps>`
  ${withLayout}
  display:${(props) => props.d || 'block'}
`;

Box.displayName = 'Box';
